import React from "react";
import {
  MDBCarousel,
  MDBCarouselItem,
  MDBCard,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";
import {} from "mdb-react-ui-kit";
import logos01 from "../assets/img/logos01a.png";
import logos02 from "../assets/img/logos02a.png";
import logos03 from "../assets/img/logos03a.png";

export const Clients = () => {
  return (
    <div className="logos">
      <h2>OUR TRUSTED CLIENTS</h2>
      <MDBCarousel interval={3000}>
        <MDBCarouselItem
          className="w-100 d-block "
          itemId={1}
          src={logos01}
          alt="..."
        />
        <MDBCarouselItem
          className="w-100 d-block"
          itemId={2}
          src={logos02}
          alt="..."
        />
        <MDBCarouselItem
          className="w-100 d-block"
          itemId={3}
          src={logos03}
          alt="..."
        />
      </MDBCarousel>
    </div>
  );
};
